import { createApp } from 'vue'
import VueTippy from 'vue-tippy'
import * as Sentry from '@sentry/vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import queryClient from './plugins/queryClient.js'
import App from './App.vue'
import router from './router'
import { initI18n } from './plugins/i18n'
import clickOutside from './plugins/click-outside'
import scrollAnimate from './plugins/scroll-animate.js'
import { store } from './store'

import './assets/main.css'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

if (
  import.meta.env.MODE !== 'development' &&
  window.location.protocol === 'http:' &&
  window.location.hostname !== 'localhost'
) {
  const { host, pathname, search, hash } = window.location
  // Force TLS on hosted environments to avoid mixed-content/session issues
  window.location.replace(`https://${host}${pathname}${search}${hash}`)
}

const app = createApp(App)
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  publishRelease: import.meta.env.MODE === 'production',
  environment: import.meta.env.VITE_BRANCH_NAME || 'production',
  release: `studio-client::${import.meta.env.VITE_BRANCH_NAME || 'production'}::untagged`,
  tracesSampleRate: 1.0,
})

app.use(store)
app.use(router)
app.use(initI18n())
app.use(VueTippy)
app.use(VueQueryPlugin, { queryClient })
app.directive('click-outside', clickOutside)
app.directive('scroll-animate', scrollAnimate)

app.mount('#app')
